// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type DeleteBusinessUnitMutationVariables = Types.Exact<{
  deleteBusinessUnitId: Types.Scalars['ID']['input'];
}>;

export type DeleteBusinessUnitMutation = { __typename?: 'Mutation' } & Pick<Types.Mutation, 'deleteBusinessUnit'>;

export const DeleteBusinessUnitDocument = /*#__PURE__*/ gql`
    mutation DeleteBusinessUnit($deleteBusinessUnitId: ID!) {
  deleteBusinessUnit(id: $deleteBusinessUnitId)
}
    `;
export type DeleteBusinessUnitMutationFn = Apollo.MutationFunction<
  DeleteBusinessUnitMutation,
  DeleteBusinessUnitMutationVariables
>;

/**
 * __useDeleteBusinessUnitMutation__
 *
 * To run a mutation, you first call `useDeleteBusinessUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBusinessUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBusinessUnitMutation, { data, loading, error }] = useDeleteBusinessUnitMutation({
 *   variables: {
 *      deleteBusinessUnitId: // value for 'deleteBusinessUnitId'
 *   },
 * });
 */
export function useDeleteBusinessUnitMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteBusinessUnitMutation, DeleteBusinessUnitMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteBusinessUnitMutation, DeleteBusinessUnitMutationVariables>(
    DeleteBusinessUnitDocument,
    options,
  );
}
export type DeleteBusinessUnitMutationHookResult = ReturnType<typeof useDeleteBusinessUnitMutation>;
export type DeleteBusinessUnitMutationOptions = Apollo.BaseMutationOptions<
  DeleteBusinessUnitMutation,
  DeleteBusinessUnitMutationVariables
>;
